import React from 'react';
import PropTypes from 'prop-types';
import TabButton from '../TabButton';
import styles from './TabMenu.module.scss';

const TabMenu = ({ items, activeTab, handleTabClick, testId }) => {
  const handleOnClick = item => {
    handleTabClick(item);
  };

  return (
    <div data-testid={testId} className={styles.container}>
      {items.map(item => <TabButton
        key={item.title}
        testId={item.testId}
        text={item.title}
        active={activeTab === item.title}
        onClick={() => handleOnClick(item)} />)}
    </div>
  );
};

TabMenu.propTypes = {
  activeTab: PropTypes.string,
  items: PropTypes.array,
  handleTabClick: PropTypes.func,
  testId: PropTypes.string
};

export default TabMenu;
